import { SpaceBetween, spacing, styled, useTranslation } from '@lessonup/ui-components';
import { getRouteForAsset } from '@lessonup/utils';
import React from 'react';
import { TRANSLATION_NAMESPACE } from '../constants';
import { Footer } from './Footer';
import { LessonModalMainWrapper } from './LayoutComponents';
import { OptionCard } from './OptionCard';

interface ChooseEditorProps {
  onSelect: (editor: 'classic' | 'new') => void;
}

export const ChooseEditor: React.FC<ChooseEditorProps> = ({ onSelect }) => {
  const { t } = useTranslation(TRANSLATION_NAMESPACE, { keyPrefix: 'chooseEditor' });

  return (
    <StyledLessonModalMainWrapper>
      <StyledSpaceBetween direction="y" spacing={spacing.size8}>
        <OptionCard
          title={t('newEditorTitle')}
          description={t('newEditorDescription')}
          image={getRouteForAsset('img/CreateLessonModal/new-editor.png')}
          onClick={() => onSelect('new')}
        />
        <OptionCard
          title={t('classicEditorTitle')}
          description={t('classicEditorDescription')}
          image={getRouteForAsset('img/CreateLessonModal/classic-editor.png')}
          onClick={() => onSelect('classic')}
        />
      </StyledSpaceBetween>
      <Footer />
    </StyledLessonModalMainWrapper>
  );
};

const StyledSpaceBetween = styled(SpaceBetween)`
  margin: 0 ${spacing.size16};
  flex-grow: 1;
  display: flex;
  justify-content: space-between;
`;

const StyledLessonModalMainWrapper = styled(LessonModalMainWrapper)`
  padding: 0 ${spacing.size16};
  height: 100%;
`;
